import * as React from 'react';
import {
  Grid, Card, CardHeader, CardContent, CardActions, Box, Typography, Paper, TextField, Button, CircularProgress,
} from '@material-ui/core';
import type { ISkillLevelGroup } from './SkillLevelTypeInterfaces';

interface SkillLevelGroupAddProps {
  formValues: ISkillLevelGroup,
  setFormValues: (values: ISkillLevelGroup) => void,
  secondaryButtonAction: () => void,
  primaryButtonAction: () => void,
  interfaceType: string,
  loading: boolean,
}

const SkillLevelGroupAdd: React.FC<SkillLevelGroupAddProps> = ({
  formValues, setFormValues, secondaryButtonAction, primaryButtonAction, interfaceType, loading,
}) => (
  <Paper>
    <Card>
      <CardHeader
        title={(
          <Typography variant="h6" display="inline">{interfaceType === 'Add' ? 'Add Skill Level Group' : 'Edit Skill Level Group'}</Typography>
        )}
        disableTypography
      />
      <CardContent>
        <Grid container xs={12}>
          <Grid item md={4} xs={4}>
            <Box pl={2}>
              <TextField
                id="skillLevelGroup-label-input"
                value={formValues?.name ?? null}
                type="text"
                label="Group Name"
                variant="outlined"
                fullWidth
                onChange={(e) => {
                  const data = e.target.value;
                  if (data) {
                    const tempFormValues: ISkillLevelGroup = { ...formValues, name: data };
                    setFormValues(tempFormValues);
                  } else {
                    const tempFormValues: ISkillLevelGroup = { ...formValues, name: '' };
                    setFormValues(tempFormValues);
                  }
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions>
        <Grid container direction="row-reverse" spacing={2}>
          <Grid item>
            <Button disabled={loading} color="primary" variant="contained" onClick={primaryButtonAction}>
              {loading ? <CircularProgress size={25} /> : <>{interfaceType === 'Add' ? 'ADD SKILL LEVEL GROUP' : 'EDIT SKILL LEVEL GROUP'}</>}
            </Button>
          </Grid>
          <Grid item>
            <Button variant="text" color="secondary" onClick={secondaryButtonAction}>{'CANCEL'}</Button>
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  </Paper>
);
export default SkillLevelGroupAdd;
